/* unplugin-vue-components disabled */import script from "./GoodsSpecs.vue?vue&type=script&setup=true&lang=js"
export * from "./GoodsSpecs.vue?vue&type=script&setup=true&lang=js"

import "./GoodsSpecs.vue?vue&type=style&index=0&id=a2a7c66c&lang=scss"

const __exports__ = script;

export default __exports__